namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_ai_request_component, {
		
		App_label: {
			flex: {
				grow: 1,
			},
		},
		
	} )
	
}
